import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LayoutComponent } from 'components/layout';
import FAQ from 'components/pages/client-onboarding/components/onboarding-details/components/faq'; // remove
import Tutorial from 'components/pages/client-onboarding/components/onboarding-details/components/tutorial'; // remove
import { useSelector, useDispatch } from 'react-redux';
import { Toaster, Loader, AccessToaster } from 'components/generic';
import { toasterSlice } from 'redux/reducers';
import { defaultRoutes } from 'config';
import { BatchUpload, CustomerUpload, ClientOnboarding, MyProfile, Onboarding, Verification, TransactionTable, PaymentPlan, CallbackRequest, Analytics, Templates, Workflow, SlabMaintenance, GenerateInvoice, UserManagement } from '../components/pages';
import { request } from 'hooks';
import { BIMContextProvider, WorkflowProvider, TemplateProvider, BatchUploadContextProvider, ClientOnboardingProvider, ProfileDetailsProvider } from 'providers';

const Routers = () => {
	const route = useSelector(state => state.route);

	const fetchState = useSelector(state => ({ loader: state?.loader, toaster: state?.toaster?.data }));
	const accessTokenState = useSelector(state => state?.acState);
	const dispatch = useDispatch();

	const handleCloseToaster = e => {
		e === 'close' && dispatch(toasterSlice?.actions?.toasterReducer(null));
	};

	const handleReload = async () => {
		try {
			const { data } = await request({ url: 'client/v1/refresh-token', method: 'get', refreshToken: true });
			localStorage.setItem('_ac', data?.data?.access_token);
			localStorage.setItem('_rc', data?.data?.refresh_token);
			window.location.reload();
		} catch (error) {
			window.location.href = '/';
			localStorage.clear();
		}
	};

	// default routes without layout component
	const defaultRoute = (
		<Routes>
			<Route
				path='/'
				element={
					<ClientOnboardingProvider>
						<ClientOnboarding />
					</ClientOnboardingProvider>
				}
			/>
			<Route
				path='/onboarding'
				element={
					<ClientOnboardingProvider>
						<Onboarding />
					</ClientOnboardingProvider>
				}
			/>
			<Route
				path='/verify'
				element={
					<ClientOnboardingProvider>
						<Verification />
					</ClientOnboardingProvider>
				}
			/>
			<Route path='/faq' element={<FAQ />} />
			<Route path='/tutorial' element={<Tutorial />} />
		</Routes>
	);

	const appRoutes = (
		<LayoutComponent>
			<Routes>
				<Route
					path='/batch-integration-maintenance'
					element={
						<BIMContextProvider>
							<CustomerUpload />
						</BIMContextProvider>
					}
				/>
				<Route
					path='/batch-upload'
					element={
						<BatchUploadContextProvider>
							<BatchUpload />
						</BatchUploadContextProvider>
					}
				/>
				<Route
					path='/my-profile'
					element={
						<ProfileDetailsProvider>
							<MyProfile />
						</ProfileDetailsProvider>
					}
				/>
				<Route
					path='/communication-templates'
					element={
						<TemplateProvider>
							<Templates />
						</TemplateProvider>
					}
				/>
				<Route path='/transaction-table' element={<TransactionTable />} />
				<Route path='/payment-plan' element={<PaymentPlan />} />
				<Route path='/callback-request' element={<CallbackRequest />} />
				<Route path='/dashboard' element={<Analytics />} />
				<Route path='/invoice-slab-maintenance' element={<SlabMaintenance />} />
				<Route path='/generate-invoice' element={<GenerateInvoice />} />
				<Route
					path='/workflow'
					element={
						<WorkflowProvider>
							<Workflow />
						</WorkflowProvider>
					}
				/>
				<Route path='/user-management' element={<UserManagement />} />
			</Routes>
		</LayoutComponent>
	);

	return (
		<>
			<Router>{defaultRoutes?.includes(route?.data) ? defaultRoute : appRoutes}</Router>
			<Loader loading={fetchState?.loader?.isLoading} />
			{fetchState?.toaster && (
				<Toaster
					information={fetchState?.toaster?.information}
					error={fetchState?.toaster?.error}
					success={fetchState?.toaster?.success}
					warning={fetchState?.toaster?.warning}
					center={fetchState?.toaster?.center}
					header={fetchState?.toaster?.header}
					content={fetchState?.toaster?.content}
					undo={fetchState?.toaster?.undo}
					buttontext={fetchState?.toaster?.buttontext}
					hideclose={fetchState?.toaster?.hideclose}
					handleUndoClose={handleCloseToaster}
					top={fetchState?.toaster?.top}
				/>
			)}
			{!accessTokenState?.data && <AccessToaster label='Oops! Something went wrong' description='Your token seems to be expired' onReload={handleReload} />}
		</>
	);
};

export default Routers;
